import { useEnabledFeatures } from '~/common/hooks/enabled-features/use-enabled-features';
import { useIsClearedEvent } from './use-is-cleared-event';

export function useIsFieldEditable() {
    const isClearedEvent = useIsClearedEvent();
    const { editClearedEvents } = useEnabledFeatures();
    return !isClearedEvent || editClearedEvents;
}
